module.exports = {
   // General
   _blank: ' ',
   select_language: 'Select Language',
   select_item_records: 'Select Item Records',
   select: 'Select',
   administration: 'Administration',
   dark_mode: 'Dark mode',
   light_mode: 'Light mode',
   required: 'Required',
   total_fields: 'Total fields',
   filter: 'Filter',
   create: 'Create',
   edit: 'Edit',
   close: 'Close',
   save: 'Save',
   update: 'Update',
   register: 'Register',
   total_records: 'Total Records',
   type_to_search: 'Type to search',
   copyright_notes: 'All rights reserved',
   member_information: 'Member Information',
   download: 'Download',
   total_rows: 'Total Rows',
   matched_count: 'Matched Count',
   unmatched_count: 'Unmatched Count',
   upload_number: 'Upload Number',
   excel_row_number: 'Excel Row Number',
   quote_reference: 'Quote Reference',
   uploader_name: 'Uploader Name',
   supported_file_types: 'Supported file types',
   mark_policy_as_template: 'Mark Policy as Template',
   mark_quotation_as_template: 'Mark Quotation as Template',
   referral_list: 'Referral List',
   referral_change_request: 'Referral Change Request',
   customer_first_name: 'Customer Firstname',
   loan_payment_upload: 'Loan Payment Upload',
   batch_payment_upload: 'Batch Payment Upload',
   upload_batch_payment: 'Upload Batch Payment',
   submit2: 'Submit',

   customer_last_name: 'Customer Lastname',
   loan_id: 'Loan ID',
   lead_id: 'Lead ID',
   first_name_kh: 'First Name Khmer',
   last_name_kh: 'Last Name Khmer',
   first_name_en: 'First Name English',
   last_name_en: 'Last Name English',

   surname_in_kh: 'Surname In Khmer',
   given_name_in_kh: 'Given Name In Khmer',
   full_name_in_kh: 'Full Name In Khmer',
   full_name_in_en: 'Full Name In English',
   monthly_repayment: 'Monthly Repayment',
   uploaded_date: 'Uploaded Date',
   surname_in_en: 'Surname In English',
   given_name_in_en: 'Given Name In English',
   telephone: 'Telephone',
   loan_amount: 'Loan Amount',
   loan_period: 'Loan Period',
   disbursement_date: 'Disbursement Date',
   telegram: 'Telegram',
   loan_information: 'Loan Information',
   personal_information: 'Personal Information',
   loan_period_hint:
      'Loan period in number of months (Ex. 12months ,36months ).',
   average_monthly_repayment_amount: 'Average Monthly Repayment Amount',
   quotation_number: 'Quotation Number',
   quotation: 'Quotation',
   template_number: 'Template Number',
   is_manual_sum_insured: 'Is Manual SumInsured',
   max_file_size: 'Max file size',
   drop_zone_intro_message:
      'Please drag files here or click to browse for files',
   view: 'View',
   delete: 'Delete',
   delete_all_risks: 'Delete All Risks',
   approved_successfully: 'Approved successfully.',
   approve_claim_settlement: 'Approve Claim Settlement',
   approve_partial: 'Partial/Payment Approval',
   declined_successfully: 'Declined successfully.',
   revert_declined_successfully: 'Revert declined successfully.',
   successfully_reverted: 'Successfully reverted.',
   notify_invoice_success: 'Invoice has been successfully created.',
   confirm_failed_revert_policy: 'Failed to revert policy approval.',
   confirm_failed_revert_quote: 'Failed to revert quote approval.',
   confirm_failed_create_invoice_policy: 'Failed to create invoice.',
   confirm_failed_approve_policy: 'Failed to approve policy.',
   confirm_failed_approve_quote: 'Failed to approve quote.',
   confirm_failed_approve_docType: 'Failed to approve {docType}.',
   confirm_failed_revert_docType: 'Failed to revert {docType} approval.',
   confirm_failed_recalcuate_commission: 'Failed to recalculate commission.',
   confirm_approve_docType: 'Are you sure to approve this {docType}?',
   confirm_revert_docType: 'Confirm revert approval for {docType} {docNumber}?',
   warning: 'Warning',
   confirm_delete_all_risks:
      'Are you sure to <span className="text-danger"> Permanently Delete All </span> Risks ?',
   confirm_approve_policy: 'Are you sure to approve policy {policyNumber}?',
   confirm_revert_policy: 'Confirm revert approval for policy {policyNumber}?',
   confirm_create_invoice_policy:
      'Are you sure to create invoice for policy {policyNumber}?',
   confirm_recalcuate_commission_policy:
      'Confirm recalcuate commission for policy {policyNumber}?',
   confirm_approve_claim:
      'You are about to approve the final settlement of [$X,XXX] for Claim {claimNumber}. This will: ',
   confirm_revert_claim: 'Are you sure to revert claim {claimNumber}?',
   decline_approve_claim: 'Are you sure to decline claim {claimNumber}?',
   ref_claim_number_batch_update: 'Ref Claim Number Batch Update',
   update_reason_decline_claim: 'Update claim decline reason {claimNumber}',
   reason_revert_claim: 'Reason Revert Claim {claimNumber}',
   revert_claim_decline: 'Revert Claim Decline',
   export_type: 'Export Type',
   personal_columns: 'Exclude Personal Columns',
   motor_columns: 'Exclude Motor Info Columns',
   property_columns: 'Exclude Property Info Columns',
   smi_columns: 'Include Smi',
   confirm_approve_quote: 'Are you sure to approve quote number {quoteNumber}?',
   confirm_revert_quote: 'Confirm revert approval for quotation {quoteNumber}?',
   confirm_create_new_ver_quote:
      'Are you sure to create new version from quotation {quoteNumber}?',
   confirm_revert_quote_to_pol:
      'Are you sure to convert quotatoin {quoteNumber} to policy?',
   confirm_approved_claim_with_no_premium_paid:
      'Premium for policy number {polNumber} is not yet collected. Proceed?',
   failed_to_revert_claim: 'Failed to revert Claim',
   failed_to_approve_claim: 'Failed to approve Claim',
   failed_to_decline_claim: 'Failed to decline Claim',
   failed_to_revert_decline_claim: 'Failed to revert decline claim',
   loan_limit_amount: 'Loan Limit Amount',
   confirm_to_delete_partner: 'Are you sure to delete partner {partnerCode}?',
   post: 'Post',
   import: 'Import',
   export: 'Export',
   dataadmin: 'Data Admin',
   login_type: 'Login type',
   reset_password: 'Reset Password',
   confirm_delete: 'Are you sure to delete?',
   confirm_release_app: 'Are you sure to release app?',
   yes: 'Yes',
   no: 'No',
   confirm_remove_all_record: 'Are you sure to remove all record?',
   default_smi: 'Default SMI',
   sucessfully_saved: 'Sucessfully saved',
   sucessfully_deleted: 'Sucessfully deleted',
   sucessfully_released: 'Successfully released',
   confirm_delete_record: 'Are you sure to delete this record?',
   confirm_void_claim: 'Are you sure to void this claim?',
   confirm_post_record: 'Are you sure to post this record?',
   confirm_update_duplicated_risk:
      'Duplicated risk information (first name, last name, date of birth) found with the following risks: {detail}',
   are_you_sure_to_proceed: 'Are you sure to proceed?',
   submit: 'Submit',
   submission: 'Submission',
   work_request_submit_success:
      'Your work request {number} has been succesfully submitted.',
   show: 'Show',
   show_only_description_in_membership: 'Show only description in membership',
   add_item: 'Add Item',
   add_items: 'Add Items',
   select_items: 'Select Items',
   select_item: 'Select Item',
   supported_excel_column_smi:
      'Supported Excel columns: Code(auto), Name, Description, Long description, Category',
   supported_excel_column_clinic:
      'Supported Excel columns: Code(auto), Name, SMI Category, Category, Price, Description, Long description',
   supported_excel_column_claim_item:
      'Supported Excel columns: Code(auto), Name, Description, Long description, Category, SMI Category',
   supported_excel_column:
      'Supported Excel columns: Code(auto), Name, Description, Long description',
   supported_excel_column_model: 'Supported Excel columns: Make,Model',
   page_error_title: 'An error occurred',
   error_code: 'Error code',
   error_message: 'Error Message',
   go_back_home: 'Go back home',
   back: 'Back',
   reference_number: 'Reference Number',
   payment_reference: 'Payment Reference',
   referral_number: 'Referral Number',
   registration_successful: ' Registration Successful!',
   your_referral_has_been_successfully_recorded:
      'Your referral has been successfully recorded.',
   please_keep_this_number_for_future_reference:
      'Please keep this number for future reference.',
   you_may_now_print_the_referral_information:
      'You may now print the referral information.',
   print_referral_info: 'Print Referral Info',
   add_another_referral: 'Add Another Referral',
   tenant: 'Tenant',
   tenants: 'Tenants',
   tenant_name: 'Tenant name',
   tenant_code: 'Tenant code',
   registered_date: 'Registered date',
   cal_commission_date: 'Calculate Commission Date',
   total_lines: 'Total Lines',
   total_risks: 'Total Risks',
   total_partners: 'Total Partners',
   base_premium: 'Base Premium',
   original_rate: 'Original Rate',
   commission_payments: 'Commission Payments',
   match_status: 'Match Status',
   commission_lines: 'Commission Lines',
   calculation: 'Calculation',
   url: 'URL',
   update_decline_reason: 'Update Decline Reason',
   print_claim_registered: 'Print Claim Registered',
   print_claim_assessment: 'Print Claim Assessment',
   current_decline_reason: 'Curerent Decline Reason',
   new_reason: 'New Reason',
   enter_description: 'Enter Description',
   create_api_key: 'Create Api Key',
   decline_reason_history: 'Decline Reason History',
   update_reason_successfully: 'Update Reason Successfully',
   disabled: 'Disabled',
   login_email: 'Login email',
   login: 'Login',
   back_to_login: 'Back to login',
   enable_row_permission: 'Enable row permission',
   data_access_parties: 'Only these teams can access this data:',
   parties: 'Parties',
   party_name: 'Party Name',
   min_value: 'Mininum value',
   field_required: 'Field required',
   min_length: 'Mininum characters',
   max_length: 'Maximum characters',
   invalid_format: 'Invalid format',
   total_users: 'Total users',
   host_name: 'Host name',
   documents: 'Documents',
   document: 'Document',
   summary: 'Summary',
   complete: 'Complete',
   drag_and_drop_or: 'Drag & drop or',
   browse: ' Browse',
   dob_required: 'Date of birth is required.',
   sum_insured_required: 'Sum Insured is required.',
   surname_in_khmer_required: 'Surname In Khmer is required.',
   province_required: 'Province is required.',
   district_required: 'District is required.',
   given_name_in_khmer_required: 'Given Name In Khmer is required.',
   loan_amount_required: 'Loan Amount is required.',
   loan_amount_validate: 'Loan amount must be greater than 0',
   loan_amount_out_limit_us_validate:
      'Loan amount cannot be greater than {amount} USD',
   loan_amount_out_limit_kh_validate:
      'Loan amount cannot be greater than {amount} Riel',
   sum_insured_validate: 'Sum Insured must be greater than 0',
   insurance_information: 'Insurance Information',
   referral_suminsured: 'Referral Sum Insured',
   submitted_date: 'Submitted Date',
   average_monthly_repayment_amount_required:
      'Average Monthly Repayment Amount is required.',
   average_monthly_repayment_amount_validate:
      'Average Monthly Repayment Amount must be greater than 0',
   currency_required: 'Currency is required.',
   lead_id_required: 'Lead ID is required.',
   id_card_required: 'ID Card is required.',
   telephone_required: 'Telephone is required.',
   telephone_validate: 'Telephone must be more than 9 digits',
   loan_period_required: 'Loan Period is required.',
   loan_period_validate: 'Loan period must be  greater than 0',
   national_id_card: 'ID Card/Birth Certificate/Passport',
   national_id_card_document: 'ID Card/Birth Certificate/Passport',
   insurance_application_document:
      'Insurance Customer Referral Form & Personal Accident Insurance Application Form',
   referral_form_document: 'Referral Form Document',
   insurance_application:
      'Insurance Referral Form & Insurance Application Form for Personal Accident',
   referral_form: 'Referral Form',
   attachment: 'Attachment',
   attachments: 'Attachments',
   insurance_app_doc_required:
      'Insurance Referral Form & Insurance Application Form for Personal Accident Document is required.',
   id_card_doc_required:
      'ID Card/Birth Certificate/Passport Document is required.',
   referral_form_doc_required: 'Referral Form Document is required.',
   referral_commissions: 'Referral Commissions',
   referral_commission: 'Referral Commission',

   your_files: 'your files',
   document_uploaded: 'Document Uploaded',
   document_name: 'Document Name',
   upload_date: 'Upload Date',
   actions: 'Actions',
   logo: 'Logo',
   address: 'Address',
   position: 'Position',
   positions: 'Positions',
   dob: 'Birth of Date',
   note: 'Note',
   topic: 'Topic',
   communication: 'Communication',

   // Dashboard
   dashboard: 'Dashboard',
   document_library: 'Document Library',
   reg_clinic_claim: 'Register Claim for Clinic',
   reg_number: 'Reg Number',
   product_by_class: 'Product by Class',
   weekly_premiums: 'Weekly Premiums',
   weekly_claims: 'Weekly Claims',
   reciepts: 'Receipts',
   create_work_req: 'Create Work Request',
   print_letter: 'Print Letter',
   print_claim_letters: 'Print Claim Letters',
   claim_decline_letter: 'Claim Decline Letter',
   claim_type: 'Claim Type',
   claim_motor_registered: 'Claim Motor Registered',
   claim_motor: 'Claims - Motor',
   claim_property: 'Claims - Property',
   claim_call_log: 'Claim Call Log',
   search_member: 'Search Member',
   search_vehicle: 'Search Vehicle',
   claim_day_passed_status: 'Claim Day Passed / Status',
   order_no: 'OrderNo',
   max_assignments: 'Max Assignments',
   //Accounting

   date: 'Date',
   doc: 'Doc',
   next_date: 'Next Date',
   next: 'Next',
   grand_total: 'Grand Total',
   sub_total: 'Sub Total',
   ship_to_address: 'Ship to address',
   billing_address: 'Billing Address',
   address_line_1: 'Address Line 1',
   address_line_2: 'Address Line 2',
   tax: 'Tax',
   total: 'Total',
   is_covered: 'Is Covered',
   exchange_rate: 'Exchange Rate',
   discount_in_percent: 'Discount %',
   discount: 'Discount',
   discounts: 'Discounts',
   discount_code2: 'Discount Code',
   gross: 'Gross',
   price: 'Price',
   as_of_date: 'As of Date',
   quantity: 'Quantity',
   pay_amount: 'Pay Amount',
   pending_amount: 'Pending Amount',
   previous_paid: 'Previous Paid',
   min_premium: 'Min. Premium',
   comission_percent: 'Commission %',
   premium: 'Premium',
   final_premium: 'Final Premium',
   annual_final_premium: 'Annual Final Premium',
   annual_premium: 'Annual Premium',
   pro_rata_premium: 'Pro-rate Premium',
   settlement_date: 'Settlement Date',
   number_of_days: 'Number of Days',
   net_premium: 'Net Premium',
   original_premium: 'Original Premium',
   refund_premium: 'Refund Premium',
   recalculate_premium: 'Recalculate Premium',
   amount: 'Amount',
   amount_usd: 'Amount (USD)',
   amount_khr: 'Amount (KHR)',
   doc_amount: 'Doc Amount',
   due_amount: 'Due Amount',
   final_due_amount: 'Final Due Amount',
   adjust_amount: 'Adjust Amount',
   total_due_amount: 'Total Due Amount',
   receipt_from: 'Receipt From',
   payment_method: 'Payment Method',
   ref_number: 'Reference Number',

   reference: 'Reference',
   payment_number: 'Payment Number',
   pay_method: 'Pay Method',
   currency: 'Currency',
   invoice_number: 'Invoice Number',
   total_paid: 'Total Paid',
   total_pay_amount: 'Total Pay Amount (USD)',
   total_pay_amount_usd: 'Total Pay Amount (USD)',
   total_pay_amount_khr: 'Total Pay Amount (KHR)',
   receipt_number: 'Receipt Number',
   receipt_amount: 'Receipt Amount',
   ship_date: 'Ship Date',
   due_date: 'Due Date',
   location: 'Location',
   partner: 'Partner',
   account_number: 'Account Number',
   payee_name: 'Payee Name',
   work_settings: 'Work Settings',
   // pay_method: 'Pay Method',
   ship_via: 'Ship via',
   tracking_number: 'Tracking Number',
   custom_condition_note: 'Custom Condition Note',
   transaction_amount: 'Transaction Amount',
   doc_date: 'Doc Date',
   amount_due: 'Amount Due',
   in_due: 'In Due',
   less_than_30days: '<30 Days',
   less_than_60days: '<60 Days',
   less_than_90days: '90 Days',
   over_90days: 'Over 90 Days',
   create_reciept: 'Create Receipt',
   revert_approve: 'Revert Approval',
   print_invoice: 'Print Invoice',
   print_treatment_statement: 'Print Treatment Statement',
   print_receipt: 'Print Receipt',
   print: 'Print ',
   print_report_designer: 'Print (Report Designer)',
   receipt_viewer: 'Receipt Viewer',
   invoice_viewer: 'Invoice Viewer',
   payment_amount: 'Payment Amount',
   print_bill: 'Print Bill',
   bill_number: 'Bill Number',
   create_payment: 'Create Payment',
   bill_viewer: 'Bill Viewer',
   grand_total_base: 'Grand Total (Base)',
   payment_viewer: 'Payment Viewer',
   foreign_currency: 'Foreign Currency',
   paid_date: 'Paid Date',
   receipt_history: 'Receipts History',
   histories: 'Histories',

   payment_history: 'Payments History',
   reciept_amount: 'Receipt Amount',
   reciept_date: 'Receipt Date',
   payment_date: 'Payment Date',
   yom: 'Year of Manufacturing',
   tonnage: 'Tonnage',
   seat: 'Seat',
   //Underwrite
   create_risk: 'Create Risk',
   risk_group: 'Risk Group',
   create_risk_master: 'Create Risk Master',
   create_smi_master: 'Create Smi Master',
   create_cover_master: 'Create Cover Master',
   family_code: 'Family Code',
   hcip_code: 'HCIP Code',
   member_code: 'Member Code',
   family_limit: 'Family Limit',
   risk_limit: 'Sum Insured (Risk Limit)',
   smi_limits: 'SMI Limits',
   smi_limit: 'SMI Limit',
   fac_applicable: 'FAC Applicable',
   fac_level: 'FAC Level',
   policy_number: 'Policy Number',
   total_premium: 'Total Premium',
   total_risk_discount: 'Total Risk Discount',
   policy_discount: 'Policy Discount',
   pay_date: 'Pay Date',
   pay_to: 'Pay To',
   max_amount: 'Max Amount',
   choose_product_to_register:
      'Kindly select from the following benefits under the Personal Accident Insurance',
   add_flow: 'Add Flow',
   create_flow: 'Create Flow',
   create_flo_approval: 'Create Flow Approval',
   flow_module: 'Flow Module',
   sequence: 'Sequence',
   is_escalation_step: 'Is Escalation Step',
   approval_flow: 'Approval Flow',
   commission: 'Commission',
   commission_type: 'Commission Type',
   custom_condition: 'Custom Condition',
   family_head: 'Family Head',
   eff_date_from: 'Effective Date From',
   hazard: 'Hazard',
   hazard_class: 'Hazard Class',
   hazard_master: 'Hazard Master',
   hazard_masters: 'Hazard Masters',
   eff_date_to: 'Effective Date To',
   issue_date: 'Issue Date',
   member_search: 'Member Search',
   vehicle_search: 'Vehicle Search',
   membership_card: 'Membership Card',
   print_membership_card: 'Print Membership Card',
   print_cards: 'Print Cards',
   my_profile: 'My Profile',
   expire_date: 'Expire Date',
   expiry_date: 'Expiry Date',
   sum_insured: 'Sum Insured',
   member_name: 'Member Name',
   min_sum_insured: 'Min Sum Insured',
   max_sum_insured: 'Max Sum Insured',
   fixed_sum_insured: 'Fixed Sum Insured',
   min_amount: 'Min Amount',
   risk_info: 'Risk Info',
   certificate_viewer: 'Certificate Viewer',
   policy_schedule_viewer: 'Policy Schedule Viewer',
   policy_fleet_viewer: 'Policy Fleet Viewer',
   quote_schedule_viewer: 'Quotation Schedule Viewer',
   quote_fleet_viewer: 'Quotation Fleet Viewer',
   risk_information: 'Risk Information',
   smi_and_covers: 'Smi and Covers',
   risk_description: 'Risk Description',
   risk_to_delete: 'Select risks to delete',
   risk_to_add: 'Risk to add',
   smi_cover: 'Smi-Cover',
   smi_name: 'SMI Name',
   risk_code: 'Risk Code',
   risk_codes: 'Risk Codes',
   producer: 'Producer',
   renewal: 'Renewal',
   renewal_quotes: 'Renewal Quotes',
   renewal_quote: 'Renewal Quote',
   view_renewal_quote: 'View Renewal Quote',

   renewal_versions: 'Renewal Versions',
   view_renewal: 'View Renewal',
   renewal_number: 'Quote Number',
   renew: 'Renew',
   discount_code: 'Discount/Loading',
   loading: 'Loading',
   referenced_quotation: 'Referenced Quotation',
   referenced_to_new_policy: 'Referenced to new policy',
   valid_days: 'Valid days',
   download_cards: 'Download Cards',
   policy_limit: 'Policy Limit',
   policy_limit_description: 'Policy Limit Description',
   version: 'Version',
   send_card_to_member: 'Send card to member',
   unit: 'Unit',
   quote_number: 'Quote Number',
   sample_risk: 'Sample Risk',
   clone_sample_risk: 'Clone Sample Risk',
   select_clinic_paneled: 'Select Clinic Paneled',
   sample_risk_required: 'Sample Risk is required',
   excel_file: 'Excel file',
   edit_risk: 'Edit Risk({riskId})',
   view_risk: 'View Risk({riskId})',
   view_tariff: 'View Tariff',
   add_risk: 'Add Risk',
   fixed_premium: 'Fixed Premium',
   original_risk: 'Original Risk',
   per_time: 'Per Time',
   comment_to: 'Comment To',
   limit_max_times: 'Max No. of times (Per Year)',
   limit_max_days: 'Max No. of days',
   limit_per_day: 'Limit per day',
   limit_per_claim: 'Limit per claim',
   payment_info_detail: 'Payment Infomation Detail',
   max_limit: 'Max Limit',

   re_calculate_commission: 'Re-Calculate Commission',
   upload_risk: 'Upload Risk',
   upload_risks_to_delete: 'Upload risks to delete',
   download_template_upload: 'Download Template/Upload',
   download_template: 'Download Template',
   upload_eff_date: 'Upload Effective Date',
   founded_risks: 'Founded Riskes',
   upload_risks: 'Upload Risks',
   create_invoice: 'Create Invoice',
   print_certificate: 'Print Certificate',
   print_fleeting: 'Print Fleeting',
   print_quotation_schedule: 'Print Quotation Schedule',
   print_claim_reimbursement_letter: 'Print Claim Reimbursement Letter',
   create_new_version: 'Create New Version',
   support_ticket_submit_success: 'Support Ticket Submit Success',
   sub_task_name: 'Sub Task Name',
   ticket_type: 'Ticket Type',
   support_ticket: 'Support Ticket',
   support_ticket_list: 'Support Ticket List',
   create_support_ticket: 'Create Support Ticket',
   convert_to_policy: 'Convert To Policy',
   upload_policies: 'Upload Policies',
   discounts_loadings: 'Discounts/Loadings',
   discussion: 'Discussion',
   territory_limit: 'Territory Limit',
   subjectivity: 'Subjectivity',
   policy_wording: 'Policy Wording',
   ncd: 'NCD',
   discount_w_example: 'Discount/Loading (i.e. 5% or 50)',
   commune_sangkat: 'Commune/Sangkat',
   district_city: 'District/City',
   district: 'District',
   commune: 'Commune',
   province: 'Province',
   village: 'Village',
   territorial_limit: 'Territorial Limit',
   sub_branch: 'Sub Branch',
   location_code: 'Location Code',
   location_name: 'Location Name',
   country: 'Country',
   construction_class: 'Construction Class',
   risk_premium: 'Risk Premium',
   risk_discount: 'Risk Discount',
   discount_loading: 'Discount/Loading',
   policies_admin: 'Policies Admin',
   view_quote: 'View Quote',
   view_policy: 'View Policy({policyId})',
   year: 'Year',
   registration_number: 'Registration No.',
   active: 'Active',
   eng_number: 'Engine Number',
   cc: 'Capacity Cubic',
   chassis_number: 'Chassis Number',
   endt_type: 'Endorsement Type',
   view_clinic_partner: 'View Clinic Partner',
   revert_decline: 'Revert Decline',
   endorsements: 'Endorsements',
   endorsement: 'Endorsement',
   endorsement_with_id: 'Endorsement({policyId})',
   endorsement_number: 'Endorsement Number',
   details: 'Details',
   total_limit: 'Total Limit',
   create_endorsement: 'Create Endorsement',
   endorsement_type: 'Endorsement Type',
   master: 'Master',
   endorsement_discount: 'Endorsement Discount',
   print_endorsement: 'Print Endorsement',
   view_endorsement: 'View Endorsement({policyId})',
   print_quote: 'Print Quote',
   print_policy: 'Print Policy',
   print_fleeting_list: 'Print Fleeting List',
   print_quote_schedule: 'Print Quotation Schedule',
   print_policy_schedule: 'Print Policy Schedule',
   print_endorsement_schedule: 'Print Endorsement Schedule',
   print_operative_endorsement: 'Print Operative Endorsement',
   member_logins: 'Member Logins',
   generate_logins: 'Generate Logins',
   premium_calc_no_risk_info:
      'Risk information is incomplete. Date of Birth is required for the system to calculate the tariff based on the setup.',
   link_risk: 'Link Risk',
   allow_claim_access: 'Allow Claim Access',
   allow_clinic_claim: 'Allow Claim at Clinic',
   nationality: 'Nationality',
   marital_status: 'Marital Status',
   height: 'Height',
   occupation: 'Occupation',
   occupation_master: 'Occupations',
   digital_card: 'Digital Card',
   clinic_and_garage: 'Clinic/Garage',
   clinic_master: 'Clinic Master',
   garage_master: 'Garage Master',
   indemnity_period: 'Indemnity Period',
   order_by: 'Order By',
   show_id_card: 'Show ID Card',
   show_family_code: 'Show Family Code',
   show_background: 'Show Background',
   show_cover_benefits: 'Show Cover Benefits & Limit',
   include_family: 'Include Family',
   discount_manual: 'Discount Manual',
   batch_delete_risk: 'Batch Delete Risks',
   upload_batch_update_risk: 'Upload Batch Update Risks',
   file_name: 'File Name',
   batch_update_risk: 'Batch Update Risks',
   apply_update_risks: 'Apply Update Risks',
   delete_selected_risks: 'Delete Selected Risks',
   risk_premium_discount: 'Premium After Discount',
   admin_fee: 'Admin Fee',
   recalc_charge: 'Recalculate Charge',
   export_risks: 'Export Risks',
   delete_history: 'Delete History',
   dispatch_no: 'Dispatch No',
   dispatch_date: 'Dispatch Date',
   select_dispatch_items: 'Select Dispatch Items',
   where_to_send: 'Destination',
   attending: 'Attention To',
   contact_number: 'Contact Number',
   delivery_method: 'Delivery Method',
   courier: 'Courier',
   courier_name: 'Courier Name',
   tracking_no: 'Tracking No',
   remarks: 'Remarks',
   document_id: 'Document ID',
   document_type: 'Document Type',
   policy_no: 'Policy No',
   document_no: 'Document No',
   copies: 'Copies',
   policy_dispatch: 'Policy Dispatch',
   mark_as_sent: 'Mark as Sent',
   add_selected: 'Add Selected',
   revert_to_draft: 'Revert to Draft',
   // Claim
   check_out_date: 'Check Out Date',
   print_claim_decline_letter: 'Print Claim Decline Letter',
   line_number: 'Line Number',
   claim_number: 'Claim Number',
   select_claim_records: 'Select claim records',
   claim_date: 'Claim Date',
   create_claim_with_type: 'Create Claim With Type',
   report: 'Report',
   report_viewer: 'Report Viewer',
   edit_report: 'Edit Report',
   accident_date: 'Accident Date',
   register_date: 'Register Date',
   notification_date: 'Notification Date',
   accident_treatment_date: 'Accident/Treatment Date',
   ref_claim_number: 'Ref Claim Number',
   ref_policy_number: 'Ref Policy Number',
   sample_claim_number: 'Sample Claim Number',
   show_ref_claim_number: 'Ref ClaimNumber Filter',
   claim_handler: 'Claim Handler',
   distance: 'Distance',
   location_remark: 'Location Remark',
   estimate_amount: 'Estimate Amount',
   estimated: 'Estimated',
   total_amount: 'Total Amount',
   paid: 'Paid',
   paid_amount: 'Paid Amount',
   payee_amount: 'Payee Amount',
   accumulated_amount: 'Accumulated Amount',
   create_new_item: 'Create New Item',
   outstanding: 'Outstanding',
   download_qr_claim_reg: 'Download QRCode',
   download_qrcode_claim: 'Download QRCode Claim',
   amount_exceed_oustanding_value: 'Amount Exceed Oustanding Value',
   pending_estimated_only: 'Pending Estimated Only',
   pending_approve_only: 'Pending Approve Only',
   pay_to_claims: 'Pay To Claims',
   claim_line: 'Claim Line',
   claim_details: 'Claim Details',
   dues: 'Dues',
   claim_dues: 'Claim Dues',
   cpl_and_crl: 'Claim Payment List & Claim Recovery List',
   claim_supplement: 'Claim Supplement',
   claim_pay_recoveries: 'Payments & Recoveries',
   ex_claim: 'Ex Claim',
   payment_id: 'Payment ID',
   reported_loss_amount: 'Reported Loss Amount',
   generate_quotation: 'Generate Quotation',
   generate_policy: 'Generate Policy',
   referral_template: 'Referral Template',
   premium_mode: 'Premium Mode',

   export_claim_history: 'Export Claim History',
   created_by: 'Created By',
   cover_details: 'Cover Details',
   coverage_limit: 'Coverage Limit',
   partner_due: 'Partner Due',
   bank_type: 'Bank Type',
   add_partner_due: 'Add Partner Due',
   pay_to_company_account: 'Pay to company account instead of insured',
   pay_full: 'Pay Full',
   pay_full_recovery_from_member: 'Pay Full and Recovery From Member',
   recovery_from_member: 'Recovery From Member',
   pay_to_account: 'Pay to Account',
   paneled_clinic: 'Paneled Clinic',
   paneled_garage: 'Paneled Garage',
   pay_deductible_now: 'Pay Deductible Now',
   insured_paid_deductible: 'Insured paid deductible',
   insured_pay_deductible: 'Insured pay deductible',
   insured_paid_the_bill: 'Insured paid the bill',
   insured_pay_the_bill: 'Insured pay the bill',
   amount_due_to_partner: 'Amount due to partner',
   amount_due_to_insured: 'Amount due to insured',
   insured_account: 'Insured Account',
   total_deductible: 'Total Deductible',
   preview: 'Preview',
   export_fleeting: 'Export Fleeting',
   preview_new_tab: 'Preview New Tab',
   register_new_claim: 'Register New Claim',
   pending_approval_only: 'Pending Approval Only',
   outstanding_only: 'Outstanding Only',
   claim_payment_req: 'Claim Payment Request',
   payment_status: 'Payment Status',
   claim_payment_reqs: 'Claim Payment Requests',
   default_payment_info: 'Default Payment Information',
   create_new_req: 'Create New Request',
   claiming_amount: 'Claiming Amount',
   agreed_amount: 'Agreed Amount',
   map_item_smi: 'Map Items to SMI',
   map_to_smi: 'Map to SMI',
   overlimit: 'Over Limit',
   limits: 'Limits',
   total_over_limit: 'Total Over Limit',
   view_limits: 'View Limits',
   maximum_limit: 'Maximum Limit',
   print_claim_offer: 'Print Claim Offer',
   claim_day_passed: 'Claim Day Passed',
   decline: 'Decline',
   approve_claim_item: 'Approve Claim Item',
   status_batch_update: 'Status Batch Update',
   batch_update_status: 'Batch Update Status',
   current_status: 'Current Status',
   statuses: 'Statuses',
   docs: 'Docs',
   request_changes: 'Request Changes',
   update_status_to: 'Update status to',
   sent_notif_to_customers: 'Sent notification to customers',
   decline_reason: 'Decline Reason',
   claim_notif: 'Claim Notification',
   claim_note: 'Claim Note',
   send_notif: 'Send Notification',
   send_to_insureds: 'Send to Insureds',
   send_to_brokers: 'Send to Brokers',
   send_to_clients: 'Send to Clients',
   reload: 'Reload',
   confirm_message:
      'Are you sure you want to proceed with the batch update? This action cannot be undone.',
   confirm_batch_update_all:
      'You are about to apply risk updates to all filtered records based on the current criteria.This action will overwrite existing data for all matching members, not just the ones selected in the list. <br/>  Are you sure you want to proceed?',
   confirm_batch_update_select:
      'You are about to apply risk updates to the members you have selected in the list. Only the selected records will be updated. Existing data for those members may be overwritten. <br/> Are you sure you want to proceed?',
   reload_comfirm_message:
      'This will reset all previous status. Are you sure to reload?',
   voided: 'Voided',
   declined: 'Declined',
   send_to: 'Send to',
   send: 'Send',
   msg_status: 'Message Status',
   add_new: '+ Add New',
   insured_amount_due: 'Insured Amount Due',
   insured_special_note: 'Insured Special Notes',
   invalid_accident_date: 'Invalid Accident Date',
   update_insured: 'Update Insured',
   claim_sms: 'Claim SMS',
   free_tier: 'Free Tier',
   cost_per_sms: 'Cost per sms',
   claimprintlettertpl: 'Claim Print Letter Template',
   preview_claim_limits: 'Preview Claim Limits',
   claim_history: 'Claim History',
   telegram_chat_id: 'Telegram Chat ID',
   vendor_type: 'Vendor Type',
   // smi_category: 'Smi Category',
   //Setup

   master_setup: 'Master Setup',
   organization: 'Organization',
   org_unit_type: 'Organizational Unit Type',
   geography_and_time: 'Geography & Time',
   reference_values: 'Reference Values',
   pricing_rate: 'Pricing & Rate',
   renewal_management: 'Renewal Management',
   download_member_card: 'Download Member Card',
   reinsurance_coinsurance: 'Reinsurance',
   claim_person: 'Claims - EMB',
   insured: 'Insured',
   organisation_units: 'Organisational Units',
   insured_name: 'Insured Name',
   id: 'ID',
   number: 'Number',
   code: 'Code',
   hcip_account_code: 'HCIP Account Code',
   level: 'Level',
   phone_number: 'Phone Number',
   first_name: 'First Name',
   last_name: 'Last Name',
   full_name: 'Full name',
   name_kh: 'Name Kh',
   type: 'Type',
   types: 'Types',
   phone1: 'Phone 1',
   write_check_to_name: 'Write check to name',
   class_name: 'Class Name',
   risk_type: 'Risk Type',
   class_code: 'Class Code',
   phone2: 'Phone 2',
   gender: 'Gender',
   list_of_values: 'List of values',
   is_corporate: 'Is corporate',
   local: 'Local',
   address_line1: 'Address Line 1',
   address_line2: 'Address Line 2',
   id_card_number: 'ID Card Number',
   id_card: 'ID Card',
   date_of_birth: 'Date of Birth',
   relation: 'Relation',
   job_title: 'Job Title',
   email: 'Email',
   branch_name: 'Branch Name',
   risk_min_refund: 'Risk Minimum Refund',
   refund_per_rule: 'Refund Percentage Rule',
   phone: 'Phone',
   name: 'Name',
   local_name: 'Local Name',
   postal_code: 'Postal Code',
   parent: 'Parent',
   head: 'Head',
   make: 'Make',
   model_name: 'Model Name',
   employee: 'Employee',
   EMPLOYEE: 'Employee name',
   BROKER: 'Broker name',
   AGENT: 'Agent name',
   CUSTOMER: 'Customer name',
   VENDOR: 'Vendor name',
   REINSURER: 'ReInsurer name',
   BANK: 'Bank name',
   INSURED: 'Insured name',
   CLINIC: 'Clinic name',
   GARAGE: 'Garage name',
   broker: 'Broker',
   insurer: 'Insurer',
   list_type: 'List Type',
   bank: 'Bank',
   bank_name: 'Bank Name',
   beneficiary_bank: 'Beneficiary Bank',
   item_code: 'Item code',
   short_description: 'Short Description',
   customer: 'Customer',
   customer_type: 'Customer Type',
   customer_notes: 'Customer Notes',
   agent: 'Agent',
   charge: 'Charge',
   charges: 'Charges',
   apply: 'Apply',
   smis_and_covers: 'SMIs and Covers',
   param_type: 'Param Type',
   is_list: 'Is List',
   values: 'Values',
   parameters: 'Parameters',
   itemname: 'Item Name',
   groups: 'Groups',
   vatin: 'VATIN',
   vat_rate: 'VAT Rate',
   tax_rate: 'Tax %',
   group_name: 'Group Name',
   premium_rate: 'Premium Rate (i.e 15 or 15%)',
   group: 'Group',
   description: 'Description',
   long_description: 'Long Description',
   company_name: 'Company name',
   contact: 'Contact',
   contact_list: 'Contact List',
   contact_name: 'Contact Name',
   contact_email: 'Contact Email',
   contact_phone1: 'Contact Phone 1',
   contact_phone2: 'Contact Phone 2',
   contact_info: 'Contact Information',
   update_contact: 'Update Contact',
   assign_claim_handler: 'Assign Claim Handler',
   assign: 'Assign',
   assign_to: 'Assign To',
   handler: 'Handler',
   assign_to_handle_claim: 'Assign Claim Handler',
   beneficiary_co_name: 'Beneficiary Co-Name',
   permissions: 'Permissions',
   item_name: 'Item name',
   list: 'List',
   cover: 'Cover',
   area: 'Area',
   holiday: 'Holiday',
   holidays: 'Holidays',
   department: 'Department',
   approve: 'Approve',
   approved_only: 'Approved Only',
   approve_all: 'Approve All',
   total_approved_amount: 'Total Approved Amount',
   total_bill_amount: 'Total Bill Amount',
   approved_amount: 'Approved Amount',
   approved_reason: 'Approved Reason',
   revertapprove: 'Revert Approve',
   claim: 'Claim',
   min_year: 'Min. Year',
   max_year: 'Max. Year',
   min_cc: 'Min. CC',
   max_cc: 'Max. CC',
   employee_commissions: 'Employee Commissions',
   min_si: 'Min. SI',
   max_si: 'Max. SI',
   make_model: 'Make & Model',
   creditterm: 'Credit Term',
   invoice: 'Invoice',
   listofvalue: 'List of Value',
   motormodel: 'Motor Model',
   third_party_liability: 'Third Party Liability',
   own_damage: 'Own Damage',
   orgunit: 'Org Unit',
   policy: 'Policy',
   policy_with_id: 'Policy({policyId})',
   claim_with_id: 'Claim({claimId})',
   productclass: 'Product Class',
   top_product_by_class: 'Top Product By Class',
   role: 'Role',
   receipt: 'Receipt',
   all: 'All',
   user: 'User',
   quote: 'Quote',
   reinsurer: 'Re Insurer',
   policypushsms: 'Policy Push SMS',
   workrequest: 'Work Request',
   tariff: 'Tariff',
   workrequestitem: 'Work Request Item',
   sysjob: 'System Job',
   sysmsg: 'System Message',
   message: 'Message',
   referral_reference: 'Referral Reference',
   register_referral_request: 'Register Referral Request',
   reuest_change: 'Request Change',
   customer_nid_or_phone_required: 'Telephone or ID Card is required',
   option1: 'Option 1',
   option2: 'Option 2',
   setting: 'Setting',
   view_details: 'View Details',
   selfclaim: 'Self Claim',
   xrate: 'Exchange Rate',
   policycancelrequest: 'Policy Cancel Request',
   payment: 'Payment',
   apikey: 'API Key',
   bill: 'Bill',
   clinic: 'Clinic',
   vendor: 'Vendor',
   view_limit_detail: 'View Limit Detail',
   msgtpl: 'Message Template',
   ar_query: 'Account Receivable',
   ap_query: 'Account Payable',
   payable_amount: 'Payable Amount',
   not_payable_amount: 'Non Payable Amount',
   over_limit: 'Over Limit',
   total_non_payable_amount: 'Total Non Payable Amount',
   garage: 'Garage',
   garages: 'Garages',
   category: 'Category',
   category_mapping: 'Category Mapping',
   map_to_category: 'Map to category',
   upload: 'Upload',
   upload_now: 'Upload now',
   message_upload_category:
      'This will upload all categories in your Excel file.',
   message_upload_claim_item:
      'This will upload all claim items in your Excel file.',
   message_upload_clinic_item:
      'This will upload all clinic items in your Excel file.',
   message_upload_risk: 'This will upload all risks in your Excel file.',
   message_upload_cover: 'This will upload all covers in your Excel file.',
   message_upload_risk_change_request:
      'This will upload all loan payment in your Excel file.',
   upload_loan_payment: 'Upload Loan Payment',
   message_upload_loan_payment:
      'This will upload all batch payment request in your Excel file.',
   message_upload_smi: 'This will upload all smis in your Excel file.',
   message_upload_condition:
      'This will upload all conditions in your Excel file.',
   message_upload_motor_model:
      'This will upload all motor models in your Excel file.',
   download_category_template: 'Download Category Template',
   download_cover_template: 'Download Cover Template',
   download_person_risk_template: 'Download Risk Template',
   download_condition_template: 'Download Condition Template',
   download_smi_template: 'Download SMI Template',
   download_claim_item_template: 'Download Claim Item Template',
   download_clinic_item_template: 'Download Clinic Item Template',
   download_motor_model_template: 'Download Motor Model Template',
   claim_categories: 'Item Categories',
   request_amount: 'Request Amount',
   claim_amount: 'Claim Amount',
   categories: 'Categories',
   default_cost: 'Default Cost',
   claim_item: 'Claim Item',
   deductible: 'Deductible',
   deductibles: 'Deductibles',
   deductible_code: 'Deductible Code',
   no_of_days: 'No of days',
   show_in_online_purchase: 'Show in online purchase?',
   item: 'Item',
   expected_date: 'Expected Date',
   product: 'Product',
   product_groups: 'Product Group',
   product_group_name: 'Product Group Name',
   in_percent: 'in Percent?',
   product_code: 'Product Code',
   product_name: 'Product Name',
   period_type: 'Period Type',
   class: 'Class',
   effective_date: 'Effective Date',
   notes: 'Notes',
   comments: 'Comments',
   '': '',
   rate: 'Rate',
   exchange_rates_table: 'Exchange Rates Table',
   address_and_contacts: 'Address and Contacts',
   deductible_in_percent: 'Deductible (i.e. 5% or 50)',
   deductible_description: 'Deductible Description',
   applied_deductibles: 'Will be applied with these deductibles',
   deductible_line: 'Deductible Line',
   product_smi_cover: 'Product-SMI-Cover',
   default: 'Default',
   due_days: 'Due Days',
   comission: 'Comission',
   clinicitem: 'Clinic Item',
   clinicitemcategory: 'Clinic Item Category',
   clinicitemprice: 'Clinic Item Price',
   commissions: 'Commissions',
   comission_value: 'Commission Value',
   currency_name: 'Currency Name',
   base_currency: 'Base Currency',
   credit_term_name: 'Credit Term Name',
   smi: 'SMI',
   smi_description: 'SMI Description',
   risk: 'Risk',
   condition: 'Condition',
   recipient: 'Recipient',
   charge_code: 'Charge Code',
   charge_name: 'Charge Name',
   claim_admins: 'Claim Admins',
   policy_status: 'Policy Status',
   quotation_status: 'Quotation Status',
   work_request_state: 'Work Request State',
   work_request_priority: 'Work Request Priority',
   row_number: 'Row Number',
   weight: 'Weight',
   claim_status: 'Claim Status',
   clinic_items: 'Items',
   work_request_admins: 'Work Request Admins',
   product_claim_admins_label:
      'Users who get notified once claim is registered for this product',
   product_workreq_admins_label:
      'Users who get notified once work request is created for this product',
   clinics: 'Clinics',
   treatment_type: 'Treatment Type',
   clinic_invoice_number: 'Clinic Invoice Number',
   account_name: 'Account Name',
   doctor: 'Doctor',
   diagnosis_category: 'Diagnosis Category ',
   diagnosis: 'Diagnosis',
   incident_description: 'Incident Description',
   internal_status: 'Internal Status',
   update_external_status_to: 'Update External Status To',
   notification: 'Notification',
   notif_msg_templates: 'Notification Message Templates',
   notif_msg_template: 'Notification Message Template',
   sms_message_templates: 'Sms Message Templates',
   email_message_templates: 'Email Message Templates',
   insured_email_tpl: 'Insured Email Template',
   insured_sms_tpl: 'Insured SMS Template',
   broke_email_tpl: 'Broker Email Template',
   broke_sms_tpl: 'Broker SMS Template',
   customer_email_tpl: 'Customer Email Template',
   customer_sms_tpl: 'Customer SMS Template',
   pay_account_number: 'Pay Account Number',
   clinic_category: 'Clinic Category',
   garage_category: 'Garage Category',
   special_note: 'Special Note',
   sources: '↓ Sources',
   step_type: 'Step Type',
   step_name: 'Step Name',
   step_one: 'Step 1',
   step_two: 'Step 2',
   step_three: 'Step 3',
   step_four: 'Step 4',
   action_type: 'Action Type',
   action_name: 'Action Name',
   required_confirmation: 'Required Confirmation',
   confirmation_message: 'Confirmation Message',
   required_comment: 'Required Comment',
   icon: 'Icon',
   entity_name: 'Entity Name',
   claim_change_request: 'Claim  Request Change',
   claim_change_requests: 'Claim  Request Changes',
   workflow_action: 'Workflow Action',
   reject: 'Reject',
   step_number: 'Step Number',
   action_code: 'Action Code',
   button_text: 'Button Text',
   button_style: 'Button Style',
   destination: 'Destination →',
   product_plans: 'Product Plans',
   plan_name: 'Product Plan name',
   copy_plan: 'Copy This Plan',
   setup_plans: 'Setup Plans',
   plan_list: 'Plan List',
   select_a_plan: 'Select a Plan',
   create_plan: 'Create Plan',
   rename_plan: 'Rename Plan',
   delete_plan: 'Delete Plan',
   start_time: 'Start Time',
   end_time: 'End Time',
   shift: 'Shift',
   leave_type: 'Leave Type',
   leave_session: 'Leave Session',
   carryover_allowed: 'Carry Over Allowed',
   default_allowance: 'Default Allowance',
   max_carryover_day: 'Max Carry Over Day',
   requires_documentation: 'Requires Documentation',
   leave_request: 'Leave Request',
   my_leave_request: 'My Leave Request',
   // Work Request

   to_department: 'To Department',
   priority: 'Priority',
   for: 'For',
   on_behalf_of: 'On behalf of',
   request_item: 'Request Items',
   reason: 'Reason',
   status: 'Status',
   source: 'Source',
   external_status: 'External Status',
   remark: 'Remark',
   request_number: 'Request Number',
   request_date: 'Request Date',
   update_status: 'Update Status',
   //Security

   login_title: 'Login',
   login_button: 'Login',
   user_id: 'User ID',
   user_name: 'User name',
   verify_code: 'Verify Code',
   batch_upload_risk_change_request: 'Batch Upload Risk Change Request',
   verify: 'Verify',
   login_name: 'User name or email or phone number',
   sum_insured_rounding: 'Sum Insured Rounding',
   handler_histories: 'Handler Histories',
   upload_batch_risk_change_request: 'Upload Batch Risk Change Request',
   username: 'User name',
   password: 'Password',
   login_notes: 'Welcome to ',
   set_password: 'Set password',
   profile: 'Profile',
   signout: 'Signout',
   account: 'Account',
   account_type: 'Account Type',
   type_detail: 'Type Detail',
   confirm_password: 'Confirm Password',
   role_name: 'Role name',
   key: 'Key',
   forgot_pwd: 'Forgot Password',
   forgot_pwd_input: 'Email or phone number',
   email_regitered: 'Enter your registered email',
   phone_registered: 'Enter your registered phone number',
   approve_or_reject_at: 'Approved / Rejected At',
   claim_account_msg:
      "Enter the email address  associated with your account and we'll send you a link to reset your password.",
   forgot_pwd_msg:
      "Enter the email address or phone number associated with your account and we'll send you a link to reset your password.",
   forgot_pwd_req_success:
      'Successfully submitted, we have emailed your password reset link.',
   claimcategory: 'Claim Category',
   claimitem: 'Claim Item',
   claimpayment: 'Claim Payment',
   clinicclaim: 'Clinic Claim',
   doclib: 'Document Library',
   lovnotif: 'LOV Notification',
   overwritepremum: 'Overwrite Premum',

   //System

   run_type: 'Run Type',
   run_time: 'Run Time',
   run_function: 'Run Function',
   enabled: 'Enabled',
   setting_name: 'Setting Name',
   value: 'Value',
   subject: 'Subject',
   body: 'Body',
   body_message: 'Body Message',
   sender: 'Sender',
   date_time: 'Date Time',
   date_type: 'Date Type',
   tries: 'Tries',
   error: 'Error',
   module_type: 'Module Type',
   fiscalyear: 'Fiscal Year',
   date_from: 'Date From',
   date_to: 'Date To',
   reset: 'Reset',
   successfully_reset: 'Successfully reset',
   hasReset: 'Has reset',

   //Report
   unpaid_claims_insured: 'Unpaid claims to insured',
   view_report: 'View Report',
   statement_of_accounts: 'Statement of Accounts',
   outstanding_reimbursement: 'Outstanding Reimbursement',
   unpaid_claims_clinic: 'Unpaid claims to clinic',
   member: 'Member',
   claim_reports: 'Claim Reports',
   accounting_reports: 'Accounting Reports',
   // Menu
   setup: 'Setup',
   master_data: 'Master Data',
   setup_update_flow: 'Setup Update Flow',
   org_units: 'Org Units',
   org_unit: 'Org Unit',
   partners: 'Partners',
   currencies: 'Currencies',
   product_masters: 'Product Masters',
   risks: 'Risks',
   smis: 'SMIs',
   covers: 'Covers',
   conditions: 'Conditions',
   condition_type: 'Condition Type',
   condition_value: 'Condition Value',
   sub_limit: 'Sub Limit',
   is_sum_si: 'Add to Sum Insured',
   view_coverage: 'View Coverage',
   coverages: 'Coverages',
   product_classes: 'Product Classes',
   products: 'Products',
   claim_items: 'Claim Items',
   claim_clinic_items: 'Items',
   claim_garage_items: 'Items',
   claim_clinic_item: 'Claim Clinic Item',
   claim_garage_item: 'Claim Garage Item',
   claimnotif: 'Send Claim Notifications',
   claimnotifmsgtpl: 'Claim Notif Message Templates',
   lov: 'List of Values (LOV)',
   work_request_items: 'Work Request Items',
   request_by: 'Request By',
   request_at: 'Request At',
   locations: 'Locations',
   motors_setup: 'Motors Setup',
   property_setup: 'Property Setup',
   makes: 'Makes',
   short_rate: 'Short Rate',
   models: 'Models',
   model: 'Model',
   special_models: 'Special Models',
   tariffs: 'Tariffs',
   areas: 'Areas',
   recordNo: 'No.',
   month: 'Months',
   multiplier: 'Multiplier',
   underwriting: 'Underwriting',
   work_requests: 'Work Requests',
   accounting_request: 'Accounting Request',
   quotation_management: 'Quotation Management',
   quotations: 'Quotations',
   policy_push_sms: 'Policy - Push SMS',
   policy_management: 'Policy Management',
   risk_member: 'Risk Member',
   policies: 'Policies',
   renewal_processing: 'Renewal Processing',
   view_renewal_processing: 'View Renewal Processing',
   generate_renewal_quote: 'Generate Renewal Quote',
   renewal_status: 'Renewal Status',
   are_you_sure_to_generate_renewal_quote:
      'Are you sure you want to generate renewal quote?',
   claims: 'Claims',
   claim_registered: 'Claim Registered',
   please_select_record: 'Please select a report.',
   payment_requests: 'Payment Requests',
   batch_payment_request: 'Batch Payment Request',
   batch_payment_request_person: 'Batch Payment Request - EMB',
   batch_claim_payment_requests: 'Batch Claim Payment Requests',
   batch_payment_requests: 'Batch Payment Requests',
   payment_request_person: 'Payment Request - EMB',
   payment_request_motor: 'Payment Request - Motor',
   payment_request_property: 'Payment Request - Property',
   claim_pay_recoverie_person: 'Payments & Recoveries - EMB',
   claim_pay_recoverie_motor: 'Payments & Recoveries - Motor',
   claim_pay_recoverie_property: 'Payments & Recoveries - Property',
   underwriting_request: 'Underwriting Request',
   notification_message_template: 'Notification Message',
   payment_code: 'Payment Code',
   bank_requirement_info:
      'Payment Method (Bank transfer) required "Bank Name" and "Account Name".',
   claimant: 'Claimant',
   claim_payment_requests: 'Claim Payment Requests',
   claim_payment_request: 'Claim Payment Request',
   accounting: 'Accounting',
   data_setup: 'Data Setup',
   items: 'Items',
   item_categories: 'Item Categories',
   credit_terms: 'Credit Terms',
   receivables: 'Receivables',
   invoices: 'Invoices',
   receipts: 'Receipts',
   receivables_query: 'Receivables Query',
   payables: 'Payables',
   bills: 'Bills',
   payments: 'Payments',
   payment_info: 'Payment Information',
   work_request_list: 'Work Request List',
   payables_query: 'Payables Query',
   security: 'Security',
   api_keys: 'API Keys',
   data_partitions: 'Data Partitions',
   risk_change_request: 'Risk Change Request',
   risk_change_requests: 'Risk Change Requests',
   users: 'Users',
   roles: 'Roles',
   system: 'System',
   system_jobs: 'System Jobs',
   settings: 'Settings',
   message_templates: 'Message Templates',
   supported_variables: 'Supported variables',
   messages: 'Messages',
   workflows: 'Workflows',
   workflow: 'Workflow',
   workflow_module: 'Workflow Module',
   workflow_modules: 'Workflow Modules',
   workflow_steps: 'Workflow Steps',
   workflow_step: 'Workflow Step',
   step: 'Step',
   step_from: 'Step From ↓',
   step_to: 'Step To →',
   module_name: 'Module Name',
   steps: 'Steps',
   requires_confirmation: 'Requires Confirmation',
   requires_comment: 'Requires Comment',
   comment_label: 'Comment Label',
   workflow_denfinitions: 'Workflow Definitions',
   workflow_definition: 'Workflow Definition',
   data_type: 'Data Type',
   next_number: 'Next Number',
   format: 'Format',
   autonum: 'Auto Numbers',
   limit: 'Limit',
   risk_min_age_warning: 'Risk minimum age warning',
   more_limits: 'More Limits',
   swift_code: 'Swift Code',
   // Header Title
   list_of_value: 'List of Values',
   moto_makes: 'Motor Makes',
   motor_models: 'Motor Models',
   motor_special_models: 'Motor Special Models',
   organisational_units: 'Organisational Units',
   system_settings: 'System Settings',
   my_claims: 'My Claims',
   my_documents: 'My Documents',
   my_claim: 'My Claim',
   claim_detail: 'Claim Detail',
   my_policies: 'My Policies',
   set_api_key: 'Set API Key Reference Data',
   update_api_key: 'Update Api Key',
   account_payables: 'Account Payables',
   account_receivables: 'Account Receivables',
   claims_receiver_admin: 'Claims Receiver Admin',
   system_setting: 'System Setting',
   register_claim: 'Register Claim',
   claim_register: 'Claim Register',
   claims_register: 'Claims Register',
   reports: 'Reports',
   reporting: 'Reporting',
   claim_call_logs: 'Claim Call Logs',
   cl001: 'Report CL001: Claim Registered',
   cl002: 'Report CL002: Statement of Accounts',
   cl003: 'Report CL003: Outstanding Reimbursement',
   cl004: 'Report CL004: Unpaid claims to clinic',
   cl005: 'Report CL005: Unpaid claims to insured',
   cl006: 'Report CL006: Claim SMS',
   exp001: 'Report EXP001: Account Payables & Aging',
   exp002: 'Report EXP002: Expense Summary',
   exp003: 'Report EXP003: Expense Detail',
   exp004: 'Report EXP004: Payment Detail',
   exp005: 'Report EXP005: Purchasing Journal for Tax Department',
   rev001: 'Report REV001: Account Receivables & Aging',
   rev002: 'Report REV002: Revenue Summary',
   rev003: 'Report REV003: Revenue Detail',
   rev004: 'Report REV004: Receipt Detail',
   no_cover: 'No Cover',
   covers_for: 'Covers for {smiName}',
   select_covers: 'Select Covers',
   limit_details_for: 'Limit details for {smiName}',
   approved: 'Approved',
   claim_letter_template: 'Claim Letter Template',
   letter_templates: 'Letter Templates',
   claim_letter_templates: 'Claim Letter Templates',
   template_list: 'Template List',
   refresh: 'Refresh',
   recalculate_premium_success: 'Recalculate Premium Successfully',
   product_plan: 'Product Plan',
   sync_with_master_smis: 'Sync with Master Smis',
   revert: 'Revert',
   family_auto_generate: 'Auto-Generate Family Code',
   claimedRisks: 'Claimed Risks',
   claim_reference_number: 'Claim Reference Number',
   total_claims: 'Total Claims',
   HCIP_Claims: 'HCIP Claims',
   claim_accumulation: 'Claim Accumulation',
   view_accumulation: 'View Accumulation',
   accumulation: 'Accumulation',
   claim_limit: 'Claim Limit',
   panel: 'Panel',
   print_schedule: 'Print Schedule',
   accumulate_paid: 'Accumulate Paid',
   balance: 'Balance',
   duplicate_risks: 'Duplicate Risks',
   total_claim_limit: 'Total Claim Limit',
   total_accumulate_paid: 'Total Accumulate Paid',
   total_balance: 'Total Balance',
   select_smi_from_product: 'Select SMI from Product',
   visibility: 'Visibility',
   smi_category: 'SMI Category',
   upload_settings: 'Upload Settings',
   upload_concurency_settings: 'Upload Concurrency Settings',
   current_upload: 'Current Upload',
   max_concurrent_upload: 'Max Concurrent Upload',
   clone_risk_as_sample_risk: 'Clone Risk As Sample Risk',
   to_this_policy: 'To Current Policy',
   to_another_policy: 'To Another Policy',
   successfully_cloned: 'Successfully Cloned',
   start_date: 'Start Date',
   end_date: 'End Date',
   tag: 'Tag',
   task_name: 'Task Name',
   assignees: 'Assignees',
   assignee: 'Assignee',
   activity: 'Activity',
   reviewed_by: 'Reviewed By',
   reviewer: 'Reviewer',
   review_status: 'Review Status',
   current_producer: 'Current Producer',
   policy_change_requests: 'Policy Change Requests',
   policy_change_request: 'Policy Change Request',
   requested_by: 'Requested By',
   claim_dashboard: 'Claims Dashboard',
   claim_task_dashboard: 'Claim Task Dashboard',
   cc_from: 'CC From',
   cc_to: 'CC To',
   endt_history: 'Endorsement History',
   created_date: 'Created at',
   rate_sources: 'Rate Sources',
   checklist_template: 'Checklist Template',
   module: 'Module',
   checklist: 'Checklist',
   checklistitem: 'Checklist Item',
   checklistmaster: 'Checklist Master',
   template_name: 'Template Name',
   checklists: 'Checklists',
   sub_tasks: 'Sub Tasks',
   use_template: 'Use Template',
   choose_this_template: 'Choose this Template',
   indemnity_period_required: 'Indemnity Period Required',
   house_number: 'House Number',
   addition_risk_details: 'Additional Risk Details',
   branch: 'Branch',
   insured_location: 'Insured Location',
   direction: 'Direction',
   linked_policy: 'Linked Policy',
   hierarchy_details: 'Hierarchical Details',
   department_hierarchy: 'Department Hierarchy',
   for_team: 'For Team',
   request_for: 'Request For (LOV)',
   expected_completed_date: 'Expected Complete Date',
   sub_task_number: 'Sub Task Number',
   created_on: 'Created on',
   secondary_email: 'Sendary Email',
   work_request_sale_deparment: 'Work Request -- Sale Department',
   work_request_uw_department: 'Work Request -- UW Department',
   sub_task: 'Sub Task',
   view_sub_task: 'View Sub Task',
   download_risk_code_template: 'Download Risk Code Templates',
   upload_risk_codes: 'Upload Risk Codes',
   use_to_calculate_premium: 'Use To Calculate Premium',
   handlers: 'Handlers',
   confirm_dialog: 'Confirm Dialog',
   update_priority: 'Update Priority',
   renewal_with_id: 'Renewal ({policyId})',
   quote_with_id: 'Quotation ({policyId})',
   work_request_convert_renewal_quote:
      'The following quotation will be converted into a renewal quote.',
   convert_to: 'Convert to',
   family_member: 'Family Member',
   handler_request_for: 'Request For',
   net_amount: 'Net Amount',
   review: 'Review',
   action: 'Action',
   proceed: 'Proceed',
   push_discount_loading: 'Push To Risk Discount/Loading',
   push_to_all_risks: 'Push to all Risks',
   select_risk_to_push_discount_to:
      'Select Risk Discount/Loading To Push from Policy to Risks ',
   confirmation_select_risk_to_push_discount_to:
      'This will override discounts/loadings in selected risks with policy values and recalculate premium. Proceed?',
   confirmation_all_risks_to_push_discount_to:
      'This will override discounts/loadings in all risks with policy values and recalculate premium. Proceed?',
   succesfully_override: 'Succesfully Override',
   risk_limit2: 'Risk Limit',
   risk_family_limit: 'Risk Family Limit',
   accumulate_paid2: 'Accumulate Paid',
   customer_group: 'Customer Group',
   distribution_channel: 'Distribution Channel',
   panel_type: 'Panel Type',
   garage_items: 'Garage Items',
   partner_due_void_confirm_msg: 'Are you sure to void?',
   partner_due_unvoid_void_confirm_msg: 'Are you sure to un-void?',
   payment_details_history: 'Payment Details History',

   //proposal

   questions: 'Questions',
   question_type: 'Question Type',
   question_text: 'Question Text',
   question: 'Question',
   display_order: 'Display Order',
   option_text: 'Option Text',
   option_value: 'Option Value',
   is_required: 'Is Required',
   proposal_master: 'Proposal Master',
   is_active: 'Is Active',
   lead_generating: 'Lead Generating',
   lead_generatings: 'Lead Generatings',
   address_kh: 'Address Kh',
   company: 'Company',
   company_kh: 'Company Kh',
   salutation: 'Salutation',
   lead_source: 'Lead Source',
   lead_type: 'Lead Type',
   proposal_generating: 'Proposal Generating',
   proposal_generatings: 'Proposal Generatings',
   lead: 'Lead',
   proposal: 'Proposal',
   proposals: 'Proposals',
   frequency: 'Frequency',
   max_months: 'Max Months',
   question_master: 'Question Master',
   amount_type: 'Amount Type',
   amount_value: 'Amount Value',
   sequence_number: 'Sequence Number',
   estimate_revenue: 'Estimate Revenue',
   convert_to_proposal: 'Convert to proposal',
   claim_admin_email_tpl: 'Claim Admin Email Template',
   claim_admin_sms_tpl: 'Claim Admin SMS Template',
   sync_with_lov: 'Sync With Claim Status',
   sync_with_lov_confirm_msg:
      'Syncing will add any new claim statuses from LOV to this template. Do you want to continue?',
   claim_notif_msg_tpl_update_confirm_msg: 'Are you sure to update?',

   has_claim: 'Has Claim',
   reinsurance_program: 'Reinsurance Program',
   program: 'Program',
   program_type: 'Program Type',
   rule_type: 'Rule Type',
   retention: 'Retention',
   layer_number: 'Layer Number',
   treaty_type: 'Treaty Type',
   payment_terms: 'Payment Terms ',
   commission_rate: 'Commission Rate',
   profit_commission: 'Profit Commission',
   experience_account: 'Experience Account',
   signed_date: 'Signed Date',
   notice_period_days: 'Notice Period Days',
   treaty_wording: 'Treaty Wording ',
   share_percent: 'Share Percent ',
   attachment_point: 'Attachment Point ',
   order_number: 'Order Number',
   applies_to_risk_type: 'Applies to Risk Type',
   applies_to_region: 'Applies to Region ',
   rules: 'Rules',
   effective_from: 'Effective From',
   effective_to: 'Effective To',
   approval_task_history: 'Approval Task History',
   pending_for_approval: 'Pending for Approval',
   assigned_role: 'Assigned Role',
   assigned_user: 'Assigned User',
   task_number: 'Task Number',
   ref_task_number: 'Ref Task Number',
   flow: 'Flow',
   is_current_step: 'Current Step',
   submit_for_approval: 'Submit for Approval',
   select_a_user_for_approval: 'Select a User for Approval',
   escalate: 'Escalate',
   request_to: 'Request to',
   requestor: 'Requestor',
   employees: 'Employees',
   brokers: 'Brokers',
   reinsurers: 'Reinsurers',
   customers: 'Customers',
   agents: 'Agents',
   vendors: 'Vendors',
   banks: 'Banks',
   partner_master: 'Partner Master',
   customer_partner_master: 'Customer/Partner Master',
   manual_temporary_password: 'Manual Temporary Password',
   use_manual_temporary_password: 'Use Manual Temporary Password',
   company_email: 'Company Email',
   temporary_password: 'Temporary Email',
   deletion_date: 'Deletion Date',
   age_warnings: 'Age Warnings',
   commission_dashboard: "Commission Dashboard"
};
